<template>
  <div class="w-full px-3 py-2 flex" :class="classes">
    <Icon :size="36" name="Alert" class="mr-3" :class="iconClasses" />
    <div
      class="font-secondary text-[14px] leading-5 tablet-h:leading-[19px] tablet-h:text-[13px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <component :is="copy" class="mb-1 tablet-h:mb-0.5" />
      <div class="text-[13px] tablet-h:text-[12px] opacity-50">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  NotificationType,
  type Notification,
} from '@/shared/graphql/legacy/generated'
import { Icon } from '@dacr/ui'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed, h } from 'vue'
import { RouterLink } from 'vue-router'

const props = defineProps<{
  notification: Notification
}>()

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-900/10': !props.notification.read,
}))

const iconClasses = computed(() => ({
  'stroke-red-700': true,
  ...(props.notification.type ===
    NotificationType.AccountPaymentRequiresAction && {
    'stroke-yellow-700': true,
  }),
}))

const copy = computed(() => {
  if (props.notification.type === NotificationType.InvoiceOverdue) {
    return h('div', [
      'We were not able to process your payment. ',
      h(
        RouterLink,
        {
          to: '/settings/billing',
          class: 'font-medium text-green-900',
        },
        () => 'Update your billing information'
      ),
      ' before you lose access to your account.',
    ])
  }

  if (
    props.notification.type === NotificationType.AccountPaymentRequiresAction
  ) {
    return h('div', [
      'Your credit card provider requires you to authenticate your payment. Please ',
      h(
        RouterLink,
        {
          to: '/settings/billing',
          class: 'font-medium text-green-900',
        },
        () => 'click here'
      ),
      ' to proceeed with authentication.',
    ])
  }

  return null
})
</script>
